<template>
  <div class="page">
    <div class="form" v-if="isShowSearch">
      <el-form
          :inline="true"
          :model="form"
          :rules="formRules"
          ref="formRef"
          size="small"
          @submit.native.prevent="onSubmit"
      >
        <div
            ref="tableSearch"
            class="table-search"
            :style="
            collapseType === 'default' && isCollapse
              ? 'height: 50px;'
              : 'height:auto;'
          "
        >
          <div ref="expandArea">
            <slot name="tableSearch"/>
          </div>

          <div ref="collapseArea" :style="isCollapse ? 'display:none;' : ''">
            <slot name="tableCollapseSearch"/>
          </div>
        </div>

        <span
            class="collapse-button"
            v-if="collapseType"
            @click="isCollapse = !isCollapse"
        >
          <i :class="isCollapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          ></i>
          <span>{{ $t(isCollapse ? "text.expand" : "text.collapse") }}</span>
        </span>
        <div class="item_button">
          <el-form-item style="margin-bottom: 0" v-if="isShowQuickSearch">
            <el-button :loading="loading" type="primary" @click="onSubmitWithNoPageable">
              {{ $t('text.quickSearch') }}
            </el-button>
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button :loading="loading" type="primary" @click="onSubmit">
              {{ $t("text.search") }}
            </el-button>
          </el-form-item>
          <!--          <el-form-item style="margin-bottom: 0" v-if="countAmount">-->
          <!--            <el-button :loading="loading" type="primary" @click="countAmount">-->
          <!--              {{ $t("text.statistics") }}-->
          <!--            </el-button>-->
          <!--          </el-form-item>-->
          <el-form-item style="margin-bottom: 0">
            <el-button :loading="loading" type="primary" @click="onReset">
              {{ $t("text.reset") }}
            </el-button>
          </el-form-item>
        </div>

        <slot name="buttonArea"/>
      </el-form>

      <div>
        <slot name="pageHeader"></slot>
      </div>
    </div>
    <div class="child">
      <slot name="customization"/>
      <el-table
          v-if="!isCustomization"
          :data="list"
          v-loading="loading"
          :row-style="{ height: '40px' }"
          :cell-style="{ padding: '2px 0' }"
          @sort-change="sortChange"
          :default-sort="sortInfo"
          highlight-current-row
          @selection-change="handleSelectionChange"
          @row-click="handelRowClick"
      >
        <template v-if="columns.length > 0">
         
          <el-table-column
            v-for="item in columns"
            v-if="item.visible !== false"
            :key="item.prop"
            :prop="item.prop"
            :label="$t(item.label)"
            :width="item.width"
            :header-align="item.headerAlign ? item.headerAlign : item.align"
            :align="item.align"
            :formatter="item.formatter"
            :sortable="item.sortable"
            :fixed="item.fixed"
            :show-overflow-tooltip="item.showOverflowTooltip"
            :class-name="item.className"
          >
            <template slot-scope="{ row, $index }">
              <slot name="tableSlotScope" :row="row" :column="item" :index="$index">
                <span
                    :style="typeof (item.cellStyle || item.style) === 'function'
                    ? (item.cellStyle || item.style)(row, item, row[item.prop], $index)
                    : (item.cellStyle || item.style) || null">
                  {{ item.formatter ? item.formatter(null, null, row[item.prop], $index) : row[item.prop] }}
                </span>
              </slot>
            </template>
          </el-table-column>
        </template>
        <slot v-else name="tableColumn"/>
      </el-table>
      <div v-loading="pageFooterLoading && loading">
        <slot name="pageFooter"></slot>
      </div>
    </div>
    <div class="pagination" v-if="paginationSwitch">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "page",
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 30,
      sort: 1,
      total: 0,
      loading: false,
      isCollapse: true,
      isShowSearchDefault: true,
      collapseType: undefined, // default/custom/undefined
    };
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    sortInfo: {
      type: Object,
      default: () => {
      },
    },
    form: {
      type: Object,
      default: null,
    },
    isShowSearch: {
      type: Boolean,
      default: true,
    },
    formRules: {
      type: Object,
      default: null,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    isShowQuickSearch: {
      type: Boolean,
      default: false
    },
    resultData: {
      type: [Array, Object],
      default: () => ([]),
    },
    pageFooterLoading: {
      type: Boolean,
      default: false
    },
    paginationSwitch: {
      type: Boolean,
      default: true
    },
    isCustomization: {
      type: Boolean,
      default: false
    },
  },
  activated() {
    if (this.isShowSearch) {
      if (this.$store.state.isKeepLive) {
        this.list = [];
        this.currentPage = 1;
        this.pageSize = 30;
        this.tableChange(this.form);
      }
      this.handleCollapseBtn();
      window.addEventListener("resize", this.handleCollapseBtn);
    }
  },

  deactivated() {
    window.removeEventListener("resize", this.handleCollapseBtn);
  },
  methods: {
    //修改每页条数触发
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.tableChange(this.form);
    },
    //翻页触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.tableChange(this.form);
    },
    //更新table数据
    tableChange(params) {
      let param = {};
      this.loading = true;
      for (let key in params) {
        let value = params[key];
        if (value !== "" && value !== null) {
          param[key] = value;
        }
      }

      param.size = this.pageSize;
      param.page = this.currentPage;

      this.$axios
          .get(this.url, {
            params: param,
            timeout: 5 * 60 * 1000,
          })
          .then((res) => {
            if (res.code === 200) {
              if (Array.isArray(res.data)) {
                // 無分頁
                this.list = res.data;
                this.total = res.data.length;
              } else {
                // 有分頁
                this.total = parseInt(res.data.total);
                this.list = res.data.list;
              }
              this.$emit('request-result', res.data);
              // this.$notify.success({
              //   title: this.$t("text.prompt"),
              //   message: '已查询到 ' + this.total + ' 笔资料'
              // });
            } else if (res.code === 500) {
              this.$notify.error({
                title: this.$t("text.prompt"),
                message: res.msg,
              });
            } else {
              this.$notify.error({
                title: this.$t("text.prompt"),
                message: this.$t("message.queryFailed"),
              });
            }
          })
          .catch(() => {
            this.$notify.error({
              title: this.$t("text.prompt"),
              message: this.$t("message.queryFailed"),
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    tableChangeWithNoPageable(params) {
      let param = {};
      this.loading = true;
      for (let key in params) {
        let value = params[key];
        if (value !== "" && value !== null) {
          param[key] = value;
        }
      }

      param.size = this.pageSize;
      param.page = this.currentPage;
      param.pageable = false;

      this.$axios
          .get(this.url, {
            params: param,
            timeout: 5 * 60 * 1000
          })
          .then((res) => {
            if (res.code === 200) {
              if (Array.isArray(res.data)) {
                // 無分頁
                this.list = res.data;
                this.total = res.data.length;
              } else {
                // 有分頁
                this.total = parseInt(res.data.total);
                this.list = res.data.list;
              }
            } else if (res.code === 500) {
              this.$notify.error({
                title: this.$t("text.prompt"),
                message: res.msg,
              });
            } else {
              this.$notify.error({
                title: this.$t("text.prompt"),
                message: this.$t("message.queryFailed"),
              });
            }
          })
          .catch(() => {
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: this.$t('message.queryFailed')
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    handleSelectionChange(val) {
      this.$emit("select-data", val);
    },
    refresh() {
      this.tableChange(this.form);
    },
    onSubmit() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          this.currentPage = 1;
          this.tableChange(this.form);
          // if (this.$parent.clearCountAmount) {
          //   this.$parent.clearCountAmount();
          // }
        } else {
          return false;
        }
      });
    },
    onSubmitWithNoPageable() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          this.currentPage = 1;
          this.tableChangeWithNoPageable(this.form);
          // if (this.$parent.clearCountAmount) {
          //   this.$parent.clearCountAmount();
          // }
        } else {
          return false;
        }
      });
    },
    // countAmount() {
    //   this.$refs["formRef"].validate((valid) => {
    //     if (valid) {
    //       //如果父组件里有统计方法，则执行统计
    //       if (this.$parent.countAmount) {
    //         this.$parent.countAmount();
    //       }
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    onReset() {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = "";
      });
      this.form.sortType = "00";
      this.$refs["formRef"].resetFields();
      this.$emit("reset");
      this.onSubmit();
    },
    sortChange({column, prop, order}) {

      const propStatus = Array.isArray(this.columns)
          ? this.columns.find(c => c && c.prop === prop)
          : null;
      const isCustom = propStatus && propStatus.sortable === 'custom';

      if (isCustom) {
        this.$emit('sortedFormatter', { column, prop, order });
        if (column.order) {
          return;
        }
      }

      let params = {
        ...this.form,
        sortType: column.order === "ascending" ? "01" : "00",
      };
      this.tableChange(params);
    },
    handleCollapseBtn() {
      if (this.$refs.collapseArea?.children?.length > 0) {
        // 自定义收缩区域
        this.collapseType = "custom";
        return;
      }

      if (this.$refs.expandArea.lastChild) {
        const parentHeight = this.$refs.expandArea.scrollHeight;
        const childHeight = this.$refs.expandArea.lastChild.scrollHeight;
        if (parentHeight > childHeight * 2) {
          this.collapseType = "default";
        } else {
          this.collapseType = undefined;
        }
      }
    },
    handelRowClick(row) {
      this.$emit("row-click", row);
    },
    loadingOpen() {
      this.loading = true;
    },
    loadingClose() {
      this.loading = false;
    },
  },
  created() {
    // this.currentPage = 1
    // this.pageSize = 30
    // this.tableChange(this.form)
    this.isShowSearchDefault = this.isShowSearch;
  },
  mounted() {
    this.$bus.$on("refresh", () => {
      this.tableChange(this.form);
    });
  },
  watch: {
    isShowSearch: {
      handler(newVal) {
        if (!this.isShowSearchDefault && newVal) {
          this.list = [];
          this.currentPage = 1;
          this.pageSize = 30;
          this.tableChange(this.form);
        }
      },
      immediate: true
    },
    resultData: {
      immediate: true,
      deep: true,
      handler(v) {
        if (v) {
          this.list = v;
        }
      }
    },
  }

};
</script>

<style scoped lang="scss">
.page {
  background: transparent;
  text-align: left;
  border: 1px solid #dce4ea;
}

.form {
  border-bottom: 1px solid #dce4ea;
  padding: 10px;
  background-color: #ffffff;
}

.item_button {
  display: initial;
}

.table-search {
  display: block;
  overflow: hidden;
}

.collapse-button {
  cursor: pointer;
  font-size: 14px;
  margin: 0 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
</style>
